export default {
  default: {
    description:
      " Your user images will be displayed across Engage so team members can easily identify you and, in the case of users and team members who appear in marketing, they will be used across print and digital products. If your user images are going to be printed make sure they're the largest size possible.",
    title: 'User Images',
  },
}
